import "core-js/modules/es.array.push.js";
var _data = [];
for (var i = 0; i < 12; i += 1) {
  _data.push({
    x: "".concat(i + 1, "\u6708"),
    y: Math.floor(Math.random() * 1000) + 200
  });
}
var tooltip = ['x*y', function (x, y) {
  return {
    name: x,
    value: y
  };
}];
var scale = [{
  dataKey: 'x',
  min: 2
}, {
  dataKey: 'y',
  title: '时间',
  min: 1,
  max: 22
}];
export default {
  name: 'Bar',
  props: ['title'],
  data: function data() {
    return {
      data: _data,
      scale: scale,
      tooltip: tooltip
    };
  }
};